/**
 * Emoji message types and constants.
 *
 * Pre-selected emoji set for in-game reactions.
 * No free text — only emojis from the AVAILABLE_EMOJIS list are allowed.
 */

export const EMOJI_MESSAGE_EVENT_TYPE = "emoji_message" as const;

export const EMOJI_IDS = [
  "thumbs_up",
  "thumbs_down",
  "grinning",
  "surprised",
  "party",
  "thinking",
  "smirk",
  "holding_back_tears",
] as const;

export type EmojiId = (typeof EMOJI_IDS)[number];

export interface EmojiEntry {
  readonly id: EmojiId;
  readonly emoji: string;
  readonly label: string;
}

export const AVAILABLE_EMOJIS: ReadonlyArray<EmojiEntry> = [
  { id: "thumbs_up", emoji: "\u{1F44D}", label: "좋아요" },
  { id: "thumbs_down", emoji: "\u{1F44E}", label: "싫어요" },
  { id: "grinning", emoji: "\u{1F600}", label: "웃음" },
  { id: "surprised", emoji: "\u{1F62E}", label: "놀람" },
  { id: "party", emoji: "\u{1F389}", label: "축하" },
  { id: "thinking", emoji: "\u{1F914}", label: "생각" },
  { id: "smirk", emoji: "\u{1F60F}", label: "능글" },
  { id: "holding_back_tears", emoji: "\u{1F979}", label: "울컥" },
] as const;

export interface EmojiMessagePayload {
  readonly emojiId: EmojiId;
  readonly displayName: string;
}

export interface EmojiMessageEvent {
  readonly id: string;
  readonly userId: string;
  readonly displayName: string;
  readonly emojiId: EmojiId;
  readonly emoji: string;
  readonly timestamp: number;
}

const EMOJI_MAP = new Map<string, EmojiEntry>(
  AVAILABLE_EMOJIS.map((e) => [e.id, e]),
);

export function getEmojiEntry(emojiId: string): EmojiEntry | undefined {
  return EMOJI_MAP.get(emojiId);
}
